import { useState, useEffect } from 'react';
import { getRepByPosition } from '@services/repService';

/**
 * Fetches a single rep by (lessonId, position) — the backward-compatible
 * position-based route (see repService.getRepByPosition). Reads don't
 * need auth (the backend route is optionalAuthenticate), so this doesn't
 * need useProgress.js's settled-flag pattern — there's no auth race to
 * guard against here.
 */
export const useRep = (lessonId, position) => {
  const [rep, setRep] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    getRepByPosition(lessonId, position)
      .then(data => { if (!cancelled) setRep(data); })
      .catch(err => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [lessonId, position]);

  return { rep, loading, error };
};

export default useRep;
